// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import HomeOutlined from '/home/gurkaransingh/scout-frontend/node_modules/@ant-design/icons/es/icons/HomeOutlined';
import SearchOutlined from '/home/gurkaransingh/scout-frontend/node_modules/@ant-design/icons/es/icons/SearchOutlined';
import UnorderedListOutlined from '/home/gurkaransingh/scout-frontend/node_modules/@ant-design/icons/es/icons/UnorderedListOutlined';
export default { HomeOutlined, SearchOutlined, UnorderedListOutlined };
